module.exports = __webpack_public_path__ + "img/light_float_ico_half.c6e4d58c.png";